import React from 'react';
import { Grid, Card, Typography } from '@mui/material';
import { Code, Description, Public, Wifi } from '@mui/icons-material';
import { PageMeta } from '../../lib/instantPageService';

interface ResourceMetricsProps {
  meta: PageMeta;
}

const ResourceMetrics: React.FC<ResourceMetricsProps> = ({ meta }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card variant="outlined" sx={{ p: 2, textAlign: 'center', height: '100%' }}>
          <Code color="primary" sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h4" fontWeight="bold">
            {meta.scripts_count}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Scripts
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {Math.round(meta.scripts_size / 1024)} KB
          </Typography>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={3}>
        <Card variant="outlined" sx={{ p: 2, textAlign: 'center', height: '100%' }}>
          <Description color="primary" sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h4" fontWeight="bold">
            {meta.stylesheets_count}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Feuilles de style
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {Math.round(meta.stylesheets_size / 1024)} KB
          </Typography>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={3}>
        <Card variant="outlined" sx={{ p: 2, textAlign: 'center', height: '100%' }}>
          <Public color="primary" sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h4" fontWeight="bold">
            {meta.images_count}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Images
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {Math.round(meta.images_size / 1024)} KB
          </Typography>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={3}>
        <Card variant="outlined" sx={{ p: 2, textAlign: 'center', height: '100%' }}>
          <Wifi color="primary" sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h4" fontWeight="bold">
            {meta.internal_links_count + meta.external_links_count}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Liens totaux
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {meta.internal_links_count} int. / {meta.external_links_count} ext.
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ResourceMetrics;
